import { z } from 'zod';
import { ApiResponse, ErrorResponse } from '@/shared/types';
import { axiosClient } from '@/shared';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  PaymentStartResponseScheme,
  type PaymentStartResponseType,
} from '@/shared/apis/payment/payment-start';

export const PatchSubscriptionPlanScheduledChangeRequestScheme = z.object({
  productId: z.number(),
  checksum: z.number(), // 계산된 결제 금액
  myCouponId: z.number().optional(), // my_coupon의 ID
  couponCode: z.string().optional(), // 쿠폰 코드
});

export type PatchSubscriptionPlanScheduledChangeRequestType = z.infer<
  typeof PatchSubscriptionPlanScheduledChangeRequestScheme
>;

/** 플랜 변경도 결제 시작 공통 계약을 쓴다. provider 별 전략은 서버가 정하고 actionType 으로 구분된다. */
export const PatchSubscriptionPlanScheduledChangeResponseScheme =
  PaymentStartResponseScheme;

export type PatchSubscriptionPlanScheduledChangeResponseType =
  PaymentStartResponseType;

type Response = ApiResponse<PatchSubscriptionPlanScheduledChangeResponseType>;

export const patchSubscriptionPlanScheduledChangeApi = async (
  spaceId: number,
  body: PatchSubscriptionPlanScheduledChangeRequestType,
) => {
  try {
    const response = await axiosClient.patch<Response>(
      '/v1.0/subscription/plan/scheduled-change',
      body,
      {
        headers: {
          'X-Space-Id': spaceId,
        },
      },
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usePatchSubscriptionPlanScheduledChangeApi = () => {
  return useMutation<
    Response,
    AxiosError<ErrorResponse>,
    { body: PatchSubscriptionPlanScheduledChangeRequestType; spaceId: number }
  >({
    mutationFn: ({ body, spaceId }) =>
      patchSubscriptionPlanScheduledChangeApi(spaceId, body),
  });
};
